/**
 * Casa Isolana logo — monogramma "CI" in cerchio terracotta + wordmark serif.
 * Uso: <Logo /> per header/footer, <Logo compact /> per solo monogramma,
 * <Logo variant="dark" /> per fondi scuri.
 */
export const Logo = ({ compact = false, variant = "light", className = "" }) => {
  const stroke = variant === "dark" ? "#F8F5F0" : "#0D253A";
  const accent = "#C86D51";
  const text = variant === "dark" ? "#F8F5F0" : "#0D253A";

  return (
    <span
      className={`inline-flex items-center gap-2.5 ${className}`}
      data-testid="site-logo"
      aria-label="Casa Isolana"
    >
      <svg
        width="34"
        height="34"
        viewBox="0 0 40 40"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="shrink-0"
      >
        <circle cx="20" cy="20" r="18.5" fill="none" stroke={accent} strokeWidth="1.2" />
        <text
          x="50%"
          y="55%"
          dominantBaseline="middle"
          textAnchor="middle"
          fontFamily='"Cormorant Garamond", "Playfair Display", Georgia, serif'
          fontSize="18"
          fontWeight="500"
          fill={stroke}
          letterSpacing="-1"
        >
          CI
        </text>
        <path
          d="M12 30.5 Q 16 28.5 20 30.5 T 28 30.5"
          fill="none"
          stroke={accent}
          strokeWidth="0.9"
          strokeLinecap="round"
        />
      </svg>
      {!compact && (
        <span className="flex flex-col leading-tight">
          <span
            className="font-display text-lg sm:text-xl font-semibold tracking-tight"
            style={{ color: text }}
          >
            Casa Isolana
          </span>
          <span
            className="hidden sm:block font-mono-alt text-[9px] uppercase tracking-[0.3em]"
            style={{ color: text, opacity: 0.55 }}
          >
            Isola delle Femmine · PA
          </span>
        </span>
      )}
    </span>
  );
};

export default Logo;
